export default "__VITE_ASSET__a1c0845b__"